import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//icon picture
import NoResultIcon from 'assets/img/no_item_found.jpg'

const NoLists = ({ icon = false }) => {
  const { t } = useTranslation(['backoffice']);
  return (
    <div className="w-100  h-100 d-flex justify-content-center align-items-center mt-3 flex-column">
      {icon && <img src={NoResultIcon}/>}
      <p>{t('noLists')}</p>
    </div>
  );
};

NoLists.propTypes = {
  icon: PropTypes.bool,
};

export default NoLists;
